import React from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
  padding-top: 80px;
`;

const HeroSection = styled.div`
  background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),
              url('/images/about-hero.jpg') center/cover no-repeat;
  padding: 100px 2rem;
  color: white;
  text-align: center;
`;

const MainHeading = styled.h1`
  font-size: clamp(2.5rem, 5vw, 4rem);
  font-family: 'Playfair Display', serif;
  margin-bottom: 1.5rem;
`;

const Section = styled.section`
  padding: 5rem 2rem;
  background-color: ${props => props.background || 'white'};
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 4rem;
  align-items: center;
`;

const TextContent = styled.div`
  p {
    color: #666;
    line-height: 1.8;
    font-size: 1.1rem;
    margin-bottom: 2rem;
    font-family: 'Lato', sans-serif;
  }
`;

const SectionTitle = styled.h2`
  font-size: 2.5rem;
  color: #333;
  font-family: 'Playfair Display', serif;
  margin-bottom: 2rem;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 60px;
    height: 3px;
    background-color: #4CAF50;
  }
`;

const VisionMissionSection = styled(Section)`
  background-color: #f9f9f9;
`;

const Card = styled.div`
  background: white;
  padding: 3rem;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  
  h3 {
    color: #333;
    font-size: 1.8rem;
    font-family: 'Playfair Display', serif;
    margin-bottom: 1.5rem;
    position: relative;

    &:after {
      content: '';
      position: absolute;
      bottom: -8px;
      left: 0;
      width: 40px;
      height: 2px;
      background-color: #4CAF50;
    }
  }

  p {
    color: #666;
    line-height: 1.8;
    font-size: 1.1rem;
    font-family: 'Lato', sans-serif;
  }
`;

function AboutPage() {
  return (
    <PageContainer>
      <HeroSection>
        <MainHeading>About Sunbold</MainHeading>
      </HeroSection>

      <Section>
        <Container>
          <ContentGrid>
            <TextContent>
              <SectionTitle>Our Story</SectionTitle>
              <p>
                Sun Bold Inc. is a proudly Liberian-owned engineering firm committed to delivering innovative, reliable, and sustainable solutions across a wide spectrum of sectors, including GSM communication, automatic power systems, network infrastructure, construction and technical installation and repair services.
              </p>
              <p>
                Founded on March 20, 2014, under the Articles of Incorporation of the Republic of Liberia, our firm has established itself as a trusted partner in Liberia's developmental undertakings. We are fully registered with the Liberian Business Registry and remain dedicated to the reconstruction and enhancement of the nation's infrastructure in the wake of past conflicts and health crises.
              </p>
            </TextContent>
          </ContentGrid>
        </Container>
      </Section>

      <VisionMissionSection>
        <Container>
          <ContentGrid>
            <Card>
              <h3>Our Mission</h3>
              <p>
                Our mission is to deliver high-quality reliable, and progressive engineering services and technologies that address the dynamic needs of Liberian enterprises and infrastructure, while simultaneously fostering economic growth and resilience within our communities.
              </p>
            </Card>
            <Card>
              <h3>Our Vision</h3>
              <p>
                Our vision is to emerge as the premier provider of comprehensive engineering and technology solutions to Liberia, spearheading innovation and sustainable development that significantly enhance the quality of life for individuals and the operational efficiency of businesses.
              </p>
            </Card>
          </ContentGrid>
        </Container>
      </VisionMissionSection>
    </PageContainer>
  );
}

export default AboutPage;
